import * as React from 'react';
import { SVGProps, memo } from 'react';
const SvgPlayCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...props}
  >
    <path
      d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
      style={{
        stroke: props.color,
        strokeWidth: props.strokeWidth,
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeDashoffset: 0,
        strokeLinejoin: 'miter',
        strokeMiterlimit: 4,
        fillRule: 'nonzero',
        opacity: props.opacity,
        overflow: props.overflow as string,
      }}
    />
    <path
      style={{
        stroke: props.color,
        strokeWidth: props.strokeWidth,
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeDashoffset: 0,
        strokeLinejoin: 'miter',
        strokeMiterlimit: 4,
        fill: props.color,
        fillRule: 'nonzero',
        opacity: props.opacity,
        overflow: props.overflow as string,
      }}
      d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"
    />
  </svg>
);
const Memo = memo(SvgPlayCircle);
export default Memo;
